jQuery_T4NT(document).ready(function ($) {

    /**
     * Variant selection changed
     */
    $(document).on("variant:changed", function (evt) {
        // console.log(evt.currentVariant);
    });


    /**
     * Accessibility fix - Menu button
     */
    function fixMenuBtn() {
        const menuBtn = document.querySelector(".t4s-push-menu-btn");

        if (menuBtn && !menuBtn.getAttribute("aria-label")) {
            menuBtn.setAttribute("aria-label", "Open navigation menu");
            menuBtn.setAttribute("aria-controls", "t4s-menu-drawer");
            menuBtn.setAttribute("aria-expanded", "false");
        }
    }

    fixMenuBtn();

    // 防止主题延迟加载（T4S常见）
    const observer = new MutationObserver(function () {
        fixMenuBtn();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});